// What each org role may DO — a mirror of backend/lib/roles.js (CRA cannot import from backend/).
// The server is the authority; these only decide what the UI draws. Change one, change both.
//
// The roles are a ladder: acquisitions agents can do everything a sales agent can, and more.

const ACQUISITIONS_ROLES = ['owner', 'admin', 'agent', 'acq_agent'];
const SELLING_ROLES = ['owner', 'admin', 'agent', 'acq_agent', 'sales_agent'];

export const canAcquire = (role) => ACQUISITIONS_ROLES.includes(role);
export const canSell = (role) => SELLING_ROLES.includes(role);
export const isOrgManager = (role) => role === 'owner' || role === 'admin';

// Paths a sales agent cannot open. Each is closed at the API too; these keep the sidebar and deep
// links from leading anywhere that would only show 403s.
export const ACQUISITIONS_PATHS = ['/deals', '/deals/new', '/import', '/mls-opportunities', '/off-market'];
